/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
  TextField,
  Autocomplete,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditCalendarOutlinedIcon from "@mui/icons-material/EditCalendarOutlined";
import { useState, useEffect } from "react";
import { getDatosAnteojoArreglo, actualizaAnteojoArreglo } from "../../services/ProduccionService";
import { getCacheData } from "../../services/CacheService";
import DatosGestionAtencionCliente from "./DatosGestionAtencionCliente";
import DatosAnteojoArreglo from "./DatosAnteojoArreglo";
import DatosBandejaActual from "./DatosBandejaActual";
import DatosAreaActual from "./DatosAreaActual";
import DatosArticulo from "./DatosArticulo";
import AgregarArticulo from "./AgregarArticulo";
import DatosAccordion from "./DatosAccordion";
import { limpiaCodigo } from "../../utils/utils";
import WaitingDialog from "../../utils/WaitingDialog";

const initialActualizarAnteojoArregloData = {
  tieneArmAsolNuevo: false,
  idArticuloArmAsolNuevo: "",
  quitaArmAsolNuevo: false,
  cambiaArmAsolNuevo: false,
  quitaCambiaArmAsolNuevoCausa: "rotura",
  quitaCambiaArmAsolNuevoIdUsuarioResponsable: "",
  quitaCambiaArmAsolNuevoMotivo: "",
  cambiaPorIdArticuloArmAsolNuevo: "",

  tieneMonturaCliente: false,
  quitaMonturaCliente: false,
  quitaMonturaClienteCausa: "rotura",
  quitaMonturaClienteIdUsuarioResponsable: "",
  quitaMonturaClienteMotivo: "",

  agregaArmAsolNuevo: false,
  agregaArmAsolNuevoIdArticulo: "",
  agregaArmAsolNuevoMotivo: "",

  agregaMonturaCliente: false,
  agregaMonturaClienteMotivo: "",

  tieneCristalBlockOD: false,
  idArticuloCristalBlockOD: "",
  quitaCristalBlockOD: false,
  cambiaCristalBlockOD: false,
  quitaCambiaCristalBlockODCausa: "rotura",
  quitaCambiaCristalBlockODIdUsuarioResponsable: "",
  quitaCambiaCristalBlockODMotivo: "",
  cambiaPorIdArticuloCristalBlockOD: "",
  agregaCristalBlockOD: false,
  agregaCristalBlockODIdArticulo: "",
  agregaCristalBlockODMotivo: "",

  tieneCristalBlockOI: false,
  idArticuloCristalBlockOI: "",
  quitaCristalBlockOI: false,
  cambiaCristalBlockOI: false,
  quitaCambiaCristalBlockOICausa: "rotura",
  quitaCambiaCristalBlockOIIdUsuarioResponsable: "",
  quitaCambiaCristalBlockOIMotivo: "",
  cambiaPorIdArticuloCristalBlockOI: "",
  agregaCristalBlockOI: false,
  agregaCristalBlockOIIdArticulo: "",
  agregaCristalBlockOIMotivo: "",
};
//
// ###########################################################################
//
const ActualizarAnteojoArregloDialog = ({
  idGestionAtencion,
  anteojoArreglo,
  codigoAnteojoArreglo,
  idGcAnteojoArreglo,
  onActualizarAnteojoArreglo,
  onClose,
  setMessage,
  setShowMessage,
}) => {
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [actualizarAnteojoArregloData, setActualizarAnteojoArregloData] = useState(
    initialActualizarAnteojoArregloData
  );
  const [usuariosObtenidos, setUsuariosObtenidos] = useState(false);
  const [usuarios, setUsuarios] = useState([]);

  const [
    valueACUsuarioQuitaCambiaArmAsolNuevo,
    setValueACUsuarioQuitaCambiaArmAsolNuevo,
  ] = useState({
    id: "",
    descripcion: "",
  });
  const [
    inputValueACUsuarioQuitaCambiaArmAsolNuevo,
    setInputValueACUsuarioQuitaCambiaArmAsolNuevo,
  ] = useState("");

  const [
    valueACUsuarioQuitaMonturaCliente,
    setValueACUsuarioQuitaMonturaCliente,
  ] = useState({
    id: "",
    descripcion: "",
  });
  const [
    inputValueACUsuarioQuitaMonturaCliente,
    setInputValueACUsuarioQuitaMonturaCliente,
  ] = useState("");

  const [
    valueACUsuarioQuitaCristalBlockOD,
    setValueACUsuarioQuitaCristalBlockOD,
  ] = useState({
    id: "",
    descripcion: "",
  });
  const [
    inputValueACUsuarioQuitaCristalBlockOD,
    setInputValueACUsuarioQuitaCristalBlockOD,
  ] = useState("");

  const [
    valueACUsuarioQuitaCristalBlockOI,
    setValueACUsuarioQuitaCristalBlockOI,
  ] = useState({
    id: "",
    descripcion: "",
  });
  const [
    inputValueACUsuarioQuitaCristalBlockOI,
    setInputValueACUsuarioQuitaCristalBlockOI,
  ] = useState("");

  const [accordionExpanded, setAccordionExpanded] = useState(false);
  const [datosAccordionSummaryCargados, setDatosAccordionSummaryCargados] = useState(false);
  const [datosObtenidos, setDatosObtenidos] = useState(false);

  // useEffect(() => {
  //   console.log("---");
  //   console.log("in ");
  //   console.log("ActualizarAnteojoArregloDialog >> useEffect []");
  //   console.log("actualizarAnteojoArregloData");
  //   console.log(actualizarAnteojoArregloData);
  //   console.log("---");
  // }, [actualizarAnteojoArregloData]);

  //
  // ################################################################################
  //
  useEffect(() => {
    const loadDatosAnteojoArreglo = async () => {

      setIsDoingSomething(true);
      const response = await getDatosAnteojoArreglo(anteojoArreglo, idGcAnteojoArreglo);
      setIsDoingSomething(false);

      if (response.ok) {
        // obtengo el area actual

        let _response = response.data.data;

        setActualizarAnteojoArregloData({
          ...actualizarAnteojoArregloData,
          tieneArmAsolNuevo: _response.tiene_arm_asol_nuevo,
          tieneMonturaCliente: _response.tiene_montura_cliente,
          idArticuloArmAsolNuevo: _response.id_articulo,
          tieneCristalBlockOD: _response.tiene_cristal_block_od,
          idArticuloCristalBlockOD: _response.id_articulo_cristal_block_od,
          tieneCristalBlockOI: _response.tiene_cristal_block_oi,
          idArticuloCristalBlockOI: _response.id_articulo_cristal_block_oi,
        });

        setDatosObtenidos(true);
      } else {
        setMessage({
          severity: response.messageSeverity,
          messageText: response.messageText,
        });
        setShowMessage(true);
        return;
      }
    };

    loadDatosAnteojoArreglo();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (accordionExpanded && !datosAccordionSummaryCargados) {
      setDatosAccordionSummaryCargados(true);
    }
  }, [accordionExpanded]);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setActualizarAnteojoArregloData({
      ...actualizarAnteojoArregloData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeQuitarCambiarArmAsolNuevoPorTipo = (e, newValue) => {
    if (newValue !== null) {
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        quitaCambiaArmAsolNuevoCausa: newValue,
      });
    }
  };
  //
  // ################################################################################
  //
  const loadUsuarios = async () => {
    const response = await getCacheData("usuario")
    if (response.ok) {
      setUsuarios(response.data.data);
      setUsuariosObtenidos(true);
    } else {
      setMessage({
        severity: response.messageSeverity,
        messageText: response.messageText,
      });
      setShowMessage(true);
      return;
    }
  };
  //
  // ################################################################################
  //
  const quitarArmAsolNuevo = () => {
    // obtengo los usuarios para establecer el usuario responsable
    if (!usuariosObtenidos) {
      loadUsuarios();
    }

    setActualizarAnteojoArregloData({
      ...actualizarAnteojoArregloData,
      quitaArmAsolNuevo: true,
      cambiaArmAsolNuevo: false,
      cambiaPorIdArticuloArmAsolNuevo: "",
    });
  };
  //
  // ################################################################################
  //
  const cambiarArmAsolNuevo = () => {
    // obtengo los usuarios para establecer el usuario responsable
    if (!usuariosObtenidos) {
      loadUsuarios();
    }

    setActualizarAnteojoArregloData({
      ...actualizarAnteojoArregloData,
      cambiaArmAsolNuevo: true,
      quitaArmAsolNuevo: false,
    });
  };
  //
  // ################################################################################
  //
  const cancelarQuitarCambiarArmAsolNuevo = () => {
    setInputValueACUsuarioQuitaCambiaArmAsolNuevo("");
    setValueACUsuarioQuitaCambiaArmAsolNuevo({ id: "", descripcion: "" });

    setActualizarAnteojoArregloData({
      ...actualizarAnteojoArregloData,
      quitaArmAsolNuevo: false,
      cambiaArmAsolNuevo: false,
      quitaCambiaArmAsolNuevoCausa: "rotura",
      quitaCambiaArmAsolNuevoIdUsuarioResponsable: "",
      quitaCambiaArmAsolNuevoMotivo: "",
      cambiaPorIdArticuloArmAsolNuevo: "",
    });
  };
  //
  // ################################################################################
  //
  const cambiarArmAsolNuevoAgregarQuitarArticulo = (parAction, parIdArticulo) => {
    if (parAction === "agregar") {
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        cambiaPorIdArticuloArmAsolNuevo: parIdArticulo,
      });
    } else {
      // quitar
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        cambiaPorIdArticuloArmAsolNuevo: "",
      });
    }
  };
  //
  // ################################################################################
  //
  const quitarMonturaCliente = () => {
    // obtengo los usuarios para establecer el usuario responsable
    if (!usuariosObtenidos) {
      loadUsuarios();
    }

    setActualizarAnteojoArregloData({
      ...actualizarAnteojoArregloData,
      quitaMonturaCliente: true,
    });
  };
  //
  // ################################################################################
  //
  const cancelarQuitarMonturaCliente = () => {
    setInputValueACUsuarioQuitaMonturaCliente("");
    setValueACUsuarioQuitaMonturaCliente({ id: "", descripcion: "" });

    setActualizarAnteojoArregloData({
      ...actualizarAnteojoArregloData,
      quitaMonturaCliente: false,
      quitaMonturaClienteCausa: "rotura",
      quitaMonturaClienteIdUsuarioResponsable: "",
      quitaMonturaClienteMotivo: "",
    });
  };
  //
  // ################################################################################
  //
  const handleChangeQuitarMonturaClientePorTipo = (e, newValue) => {
    if (newValue !== null) {
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        quitaMonturaClienteCausa: newValue,
      });
    }
  };
  //
  // ################################################################################
  //
  const agregarArmAsolNuevo = () => {
    setActualizarAnteojoArregloData({
      ...actualizarAnteojoArregloData,
      agregaArmAsolNuevo: true,
      agregaMonturaCliente: false,
      agregaMonturaClienteMotivo: "",
    });
  };
  //
  // ################################################################################
  //
  const agregarArmAsolNuevoAgregarArticulo = (parAction, parIdArticulo) => {
    setActualizarAnteojoArregloData({
      ...actualizarAnteojoArregloData,
      agregaArmAsolNuevoIdArticulo: parIdArticulo,
    });
  };
  //
  // ################################################################################
  //
  const agregarMonturaCliente = () => {
    setActualizarAnteojoArregloData({
      ...actualizarAnteojoArregloData,
      agregaMonturaCliente: true,
      agregaArmAsolNuevo: false,
      agregaArmAsolNuevoIdArticulo: "",
      agregaArmAsolNuevoMotivo: "",
    });
  };
  //
  // ################################################################################
  //
  const cancelarArmAsolNuevoMonturaCliente = () => {
    setActualizarAnteojoArregloData({
      ...actualizarAnteojoArregloData,
      agregaArmAsolNuevo: false,
      agregaArmAsolNuevoIdArticulo: "",
      agregaArmAsolNuevoMotivo: "",
      agregaMonturaCliente: false,
      agregaMonturaClienteMotivo: "",
    });
  };
  //
  // ################################################################################
  //
  const quitarCristalBlock = (parOjo) => {
    // obtengo los usuarios para establecer el usuario responsable
    if (!usuariosObtenidos) {
      loadUsuarios();
    }

    if (parOjo === "OD") {
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        quitaCristalBlockOD: true,
        cambiaCristalBlockOD: false,
        cambiaPorIdArticuloCristalBlockOD: "",
      });
    } else {
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        quitaCristalBlockOI: true,
        cambiaCristalBlockOI: false,
        cambiaPorIdArticuloCristalBlockOI: "",
      });
    }
  };
  //
  // ################################################################################
  //
  const cambiarCristalBlock = (parOjo) => {
    // obtengo los usuarios para establecer el usuario responsable
    if (!usuariosObtenidos) {
      loadUsuarios();
    }

    if (parOjo === "OD") {
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        cambiaCristalBlockOD: true,
        quitaCristalBlockOD: false,
      });
    } else {
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        cambiaCristalBlockOI: true,
        quitaCristalBlockOI: false,
      });
    }
  };
  //
  // ################################################################################
  //
  const cancelarQuitarCambiarCristalBlock = (parOjo) => {
    if (parOjo === "OD") {
      setInputValueACUsuarioQuitaCristalBlockOD("");
      setValueACUsuarioQuitaCristalBlockOD({ id: "", descripcion: "" });
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        quitaCristalBlockOD: false,
        cambiaCristalBlockOD: false,
        quitaCambiaCristalBlockODCausa: "rotura",
        quitaCambiaCristalBlockODIdUsuarioResponsable: "",
        quitaCambiaCristalBlockODMotivo: "",
        cambiaPorIdArticuloCristalBlockOD: "",
      });
    } else {
      setInputValueACUsuarioQuitaCristalBlockOI("");
      setValueACUsuarioQuitaCristalBlockOI({ id: "", descripcion: "" });
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        quitaCristalBlockOI: false,
        cambiaCristalBlockOI: false,
        quitaCambiaCristalBlockOICausa: "rotura",
        quitaCambiaCristalBlockOIIdUsuarioResponsable: "",
        quitaCambiaCristalBlockOIMotivo: "",
        cambiaPorIdArticuloCristalBlockOI: "",
      });
    }
  };
  //
  // ################################################################################
  //
  const handleChangeQuitarCambiarCristalBlockODPorTipo = (e, newValue) => {
    if (newValue !== null) {
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        quitaCambiaCristalBlockODCausa: newValue,
      });
    }
  };
  //
  // ################################################################################
  //
  const handleChangeQuitarCambiarCristalBlockOIPorTipo = (e, newValue) => {
    if (newValue !== null) {
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        quitaCambiaCristalBlockOICausa: newValue,
      });
    }
  };
  //
  // ################################################################################
  //
  const cambiarCristalBlockAgregarQuitarArticulo = (parAction, parIdArticulo, parOjo) => {
    if (parOjo === "OD") {
      if (parAction === "agregar") {
        setActualizarAnteojoArregloData({
          ...actualizarAnteojoArregloData,
          cambiaPorIdArticuloCristalBlockOD: parIdArticulo,
        });
      } else {
        // quitar
        setActualizarAnteojoArregloData({
          ...actualizarAnteojoArregloData,
          cambiaPorIdArticuloCristalBlockOD: "",
        });
      }
    } else {
      if (parAction === "agregar") {
        setActualizarAnteojoArregloData({
          ...actualizarAnteojoArregloData,
          cambiaPorIdArticuloCristalBlockOI: parIdArticulo,
        });
      } else {
        // quitar
        setActualizarAnteojoArregloData({
          ...actualizarAnteojoArregloData,
          cambiaPorIdArticuloCristalBlockOI: "",
        });
      }
    }
  };
  //
  // ################################################################################
  //
  const agregaCristalBlock = (parOjo) => {
    if (parOjo === "OD") {
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        agregaCristalBlockOD: true,
      });
    } else {
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        agregaCristalBlockOI: true,
      });
    }
  };
  //
  // ################################################################################
  //
  const cancelarAgregarCristalBlock = (parOjo) => {
    if (parOjo === "OD") {
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        agregaCristalBlockOD: false,
        agregaCristalBlockODIdArticulo: "",
        agregaCristalBlockODMotivo: "",
      });
    } else {
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        agregaCristalBlockOI: false,
        agregaCristalBlockOIIdArticulo: "",
        agregaCristalBlockOIMotivo: "",
      });
    }
  };
  //
  // ################################################################################
  //
  const agregaCristalBlockAgregarArticulo = (parAction, parIdArticulo, parOjo) => {
    if (parOjo === "OD") {
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        agregaCristalBlockODIdArticulo: parIdArticulo,
      });
    } else {
      setActualizarAnteojoArregloData({
        ...actualizarAnteojoArregloData,
        agregaCristalBlockOIIdArticulo: parIdArticulo,
      });
    }
  };
  //
  // ################################################################################
  //
  const getAreaActual = async () => { };
  //
  // ################################################################################
  //
  const getBandejaActual = async () => { };
  //
  // ################################################################################
  //
  const ActualizarAnteojoArreglo = async () => {
    console.log("---");
    console.log("in ActualizarAnteojoArreglo");
    console.log("actualizarAnteojoArregloData");
    console.log(actualizarAnteojoArregloData);
    console.log();

    if (
      !actualizarAnteojoArregloData.agregaArmAsolNuevo &&
      !actualizarAnteojoArregloData.agregaMonturaCliente &&
      !actualizarAnteojoArregloData.agregaCristalBlockOD &&
      !actualizarAnteojoArregloData.agregaCristalBlockOI &&
      !actualizarAnteojoArregloData.cambiaArmAsolNuevo &&
      !actualizarAnteojoArregloData.cambiaCristalBlockOD &&
      !actualizarAnteojoArregloData.cambiaCristalBlockOI &&
      !actualizarAnteojoArregloData.quitaArmAsolNuevo &&
      !actualizarAnteojoArregloData.quitaMonturaCliente &&
      !actualizarAnteojoArregloData.quitaCristalBlockOD &&
      !actualizarAnteojoArregloData.quitaCristalBlockOI
    ) {
      setMessage({
        severity: "error",
        messageText: "Debes llevar a cabo alguna acción para actualizar el Anteojo / Arreglo",
      });
      setShowMessage(true);
      return;
    }

    if (actualizarAnteojoArregloData.tieneArmAsolNuevo) {
      // si tiene arm/sol nuevo

      if (actualizarAnteojoArregloData.quitaArmAsolNuevo) {
        // si esta quitando el arm/sol nuevo

        if (!actualizarAnteojoArregloData.quitaCambiaArmAsolNuevoIdUsuarioResponsable) {
          setMessage({
            severity: "error",
            messageText:
              "Debes ingresar el usuario responsable de quitar el Armazón / Anteojo de Sol",
          });
          setShowMessage(true);
          return;
        }

        if (!actualizarAnteojoArregloData.quitaCambiaArmAsolNuevoMotivo) {
          setMessage({
            severity: "error",
            messageText: "Debes ingresar el motivo por el que se quita el Armazón / Anteojo de Sol",
          });
          setShowMessage(true);
          return;
        }
      } else if (actualizarAnteojoArregloData.cambiaArmAsolNuevo) {
        // si esta cambiando el arm/sol nuevo

        if (!actualizarAnteojoArregloData.quitaCambiaArmAsolNuevoIdUsuarioResponsable) {
          setMessage({
            severity: "error",
            messageText:
              "Debes ingresar el usuario responsable de cambiar el Armazón / Anteojo de Sol",
          });
          setShowMessage(true);
          return;
        }

        if (!actualizarAnteojoArregloData.quitaCambiaArmAsolNuevoMotivo) {
          setMessage({
            severity: "error",
            messageText:
              "Debes ingresar el motivo por el que se cambia el Armazón / Anteojo de Sol",
          });
          setShowMessage(true);
          return;
        }

        if (!actualizarAnteojoArregloData.cambiaPorIdArticuloArmAsolNuevo) {
          setMessage({
            severity: "error",
            messageText: "Debes ingresar el nuevo Armazón / Anteojo de Sol",
          });
          setShowMessage(true);
          return;
        }
      }
    } else if (actualizarAnteojoArregloData.tieneMonturaCliente) {
      // si tiene montura del cliente

      if (actualizarAnteojoArregloData.quitaMonturaCliente) {
        // si esta quitando la montura del cliente

        if (!actualizarAnteojoArregloData.quitaMonturaClienteIdUsuarioResponsable) {
          setMessage({
            severity: "error",
            messageText: "Debes ingresar el usuario responsable de quitar la montura del Cliente",
          });
          setShowMessage(true);
          return;
        }

        if (!actualizarAnteojoArregloData.quitaMonturaClienteMotivo) {
          setMessage({
            severity: "error",
            messageText: "Debes ingresar el motivo por el que se quita la montura del Cliente",
          });
          setShowMessage(true);
          return;
        }
      }
    } else {
      // no tiene arm/asol nuevo ni tiene montura del cliente

      if (actualizarAnteojoArregloData.agregaArmAsolNuevo) {
        // si esta agregando el arm/sol nuevo

        if (!actualizarAnteojoArregloData.agregaArmAsolNuevoIdArticulo) {
          setMessage({
            severity: "error",
            messageText: "Debes ingresar el nuevo Armazón / Anteojo de Sol",
          });
          setShowMessage(true);
          return;
        }

        if (!actualizarAnteojoArregloData.agregaArmAsolNuevoMotivo) {
          setMessage({
            severity: "error",
            messageText:
              "Debes ingresar el motivo por el que se agrega el nuevo Armazón / Anteojo de Sol",
          });
          setShowMessage(true);
          return;
        }
      } else if (actualizarAnteojoArregloData.agregaMonturaCliente) {
        // si esta agregando la montura del cliente

        if (!actualizarAnteojoArregloData.agregaMonturaClienteMotivo) {
          setMessage({
            severity: "error",
            messageText: "Debes ingresar el motivo o detalles de la montura del Cliente",
          });
          setShowMessage(true);
          return;
        }
      }
    }

    if (actualizarAnteojoArregloData.tieneCristalBlockOD) {
      // si tiene cristal block OD

      if (actualizarAnteojoArregloData.quitaCristalBlockOD) {
        // si esta quitando el cristal block OD

        if (!actualizarAnteojoArregloData.quitaCambiaCristalBlockODIdUsuarioResponsable) {
          setMessage({
            severity: "error",
            messageText:
              "Debes ingresar el usuario responsable de quitar el Cristal / Block del OD",
          });
          setShowMessage(true);
          return;
        }

        if (!actualizarAnteojoArregloData.quitaCambiaCristalBlockODMotivo) {
          setMessage({
            severity: "error",
            messageText: "Debes ingresar el motivo por el que se quita el Cristal / Block del OD",
          });
          setShowMessage(true);
          return;
        }
      } else if (actualizarAnteojoArregloData.cambiaCristalBlockOD) {
        // si esta cambiando el cristal block OD

        if (!actualizarAnteojoArregloData.quitaCambiaCristalBlockODIdUsuarioResponsable) {
          setMessage({
            severity: "error",
            messageText:
              "Debes ingresar el usuario responsable de cambiar el Cristal / Block del OD",
          });
          setShowMessage(true);
          return;
        }

        if (!actualizarAnteojoArregloData.quitaCambiaCristalBlockODMotivo) {
          setMessage({
            severity: "error",
            messageText: "Debes ingresar el motivo por el que se cambia el Cristal / Block del OD",
          });
          setShowMessage(true);
          return;
        }

        if (!actualizarAnteojoArregloData.cambiaPorIdArticuloCristalBlockOD) {
          setMessage({
            severity: "error",
            messageText: "Debes ingresar el nuevo Cristal / Block del OD",
          });
          setShowMessage(true);
          return;
        }
      }
    } else {
      // no tiene cristal block OD

      if (actualizarAnteojoArregloData.agregaCristalBlockOD) {
        // si esta agregando el cristal block OD

        if (!actualizarAnteojoArregloData.agregaCristalBlockODIdArticulo) {
          setMessage({
            severity: "error",
            messageText: "Debes ingresar el nuevo Cristal / Block del OD",
          });
          setShowMessage(true);
          return;
        }

        if (!actualizarAnteojoArregloData.agregaCristalBlockODMotivo) {
          setMessage({
            severity: "error",
            messageText:
              "Debes ingresar el motivo por el que se agrega el nuevo Cristal / Block del OD",
          });
          setShowMessage(true);
          return;
        }
      }
    }

    if (actualizarAnteojoArregloData.tieneCristalBlockOI) {
      // si tiene cristal block OI

      if (actualizarAnteojoArregloData.quitaCristalBlockOI) {
        // si esta quitando el cristal block OI

        if (!actualizarAnteojoArregloData.quitaCambiaCristalBlockOIIdUsuarioResponsable) {
          setMessage({
            severity: "error",
            messageText:
              "Debes ingresar el usuario responsable de quitar el Cristal / Block del OI",
          });
          setShowMessage(true);
          return;
        }

        if (!actualizarAnteojoArregloData.quitaCambiaCristalBlockOIMotivo) {
          setMessage({
            severity: "error",
            messageText: "Debes ingresar el motivo por el que se quita el Cristal / Block del OI",
          });
          setShowMessage(true);
          return;
        }
      } else if (actualizarAnteojoArregloData.cambiaCristalBlockOI) {
        // si esta cambiando el cristal block OI

        if (!actualizarAnteojoArregloData.quitaCambiaCristalBlockOIIdUsuarioResponsable) {
          setMessage({
            severity: "error",
            messageText:
              "Debes ingresar el usuario responsable de cambiar el Cristal / Block del OI",
          });
          setShowMessage(true);
          return;
        }

        if (!actualizarAnteojoArregloData.quitaCambiaCristalBlockOIMotivo) {
          setMessage({
            severity: "error",
            messageText: "Debes ingresar el motivo por el que se cambia el Cristal / Block del OI",
          });
          setShowMessage(true);
          return;
        }

        if (!actualizarAnteojoArregloData.cambiaPorIdArticuloCristalBlockOI) {
          setMessage({
            severity: "error",
            messageText: "Debes ingresar el nuevo Cristal / Block del OI",
          });
          setShowMessage(true);
          return;
        }
      }
    } else {
      // no tiene cristal block OI

      if (actualizarAnteojoArregloData.agregaCristalBlockOI) {
        // si esta agregando el cristal block OI

        if (!actualizarAnteojoArregloData.agregaCristalBlockOIIdArticulo) {
          setMessage({
            severity: "error",
            messageText: "Debes ingresar el nuevo Cristal / Block del OI",
          });
          setShowMessage(true);
          return;
        }

        if (!actualizarAnteojoArregloData.agregaCristalBlockOIMotivo) {
          setMessage({
            severity: "error",
            messageText:
              "Debes ingresar el motivo por el que se agrega el nuevo Cristal / Block del OI",
          });
          setShowMessage(true);
          return;
        }
      }
    }

    let _ActualizarAnteojoArregloObject = {
      anteojo_arreglo: anteojoArreglo,
      id_gc_anteojo_arreglo: idGcAnteojoArreglo,

      // tieneArmAsolNuevo: actualizarAnteojoArregloData.tieneArmAsolNuevo,
      // idArticuloArmAsolNuevo: actualizarAnteojoArregloData.idArticuloArmAsolNuevo,

      quita_arm_asol_nuevo: actualizarAnteojoArregloData.quitaArmAsolNuevo,
      cambia_arm_asol_nuevo: actualizarAnteojoArregloData.cambiaArmAsolNuevo,
      quita_cambia_arm_asol_nuevo_causa: actualizarAnteojoArregloData.quitaCambiaArmAsolNuevoCausa,
      quita_cambia_arm_asol_nuevo_id_usuario_responsable:
        actualizarAnteojoArregloData.quitaCambiaArmAsolNuevoIdUsuarioResponsable,
      quita_cambia_arm_asol_nuevo_motivo:
        actualizarAnteojoArregloData.quitaCambiaArmAsolNuevoMotivo,
      cambia_por_id_articulo_arm_asol_nuevo:
        actualizarAnteojoArregloData.cambiaPorIdArticuloArmAsolNuevo,

      // tieneMonturaCliente: actualizarAnteojoArregloData.tieneMonturaCliente,

      quita_montura_cliente: actualizarAnteojoArregloData.quitaMonturaCliente,
      quita_montura_cliente_causa: actualizarAnteojoArregloData.quitaMonturaClienteCausa,
      quita_montura_cliente_id_usuario_responsable:
        actualizarAnteojoArregloData.quitaMonturaClienteIdUsuarioResponsable,
      quita_montura_cliente_motivo: actualizarAnteojoArregloData.quitaMonturaClienteMotivo,

      agrega_arm_asol_nuevo: actualizarAnteojoArregloData.agregaArmAsolNuevo,
      agrega_arm_asol_nuevo_id_articulo: actualizarAnteojoArregloData.agregaArmAsolNuevoIdArticulo,
      agrega_arm_asol_nuevo_motivo: actualizarAnteojoArregloData.agregaArmAsolNuevoMotivo,

      agrega_montura_cliente: actualizarAnteojoArregloData.agregaMonturaCliente,
      agrega_montura_cliente_motivo: actualizarAnteojoArregloData.agregaMonturaClienteMotivo,

      // tieneCristalBlockOD: actualizarAnteojoArregloData.tieneCristalBlockOD,
      // idArticuloCristalBlockOD: actualizarAnteojoArregloData.idArticuloCristalBlockOD,

      quita_cristal_block_od: actualizarAnteojoArregloData.quitaCristalBlockOD,
      cambia_cristal_block_od: actualizarAnteojoArregloData.cambiaCristalBlockOD,
      quita_cambia_cristal_block_od_causa:
        actualizarAnteojoArregloData.quitaCambiaCristalBlockODCausa,
      quita_cambia_cristal_block_od_id_usuario_responsable:
        actualizarAnteojoArregloData.quitaCambiaCristalBlockODIdUsuarioResponsable,
      quita_cambia_cristal_block_od_motivo:
        actualizarAnteojoArregloData.quitaCambiaCristalBlockODMotivo,
      cambia_por_id_articulo_cristal_block_od:
        actualizarAnteojoArregloData.cambiaPorIdArticuloCristalBlockOD,

      agrega_cristal_block_od: actualizarAnteojoArregloData.agregaCristalBlockOD,
      agrega_cristal_block_od_id_articulo:
        actualizarAnteojoArregloData.agregaCristalBlockODIdArticulo,
      agrega_cristal_block_od_motivo: actualizarAnteojoArregloData.agregaCristalBlockODMotivo,

      // tieneCristalBlockOI: actualizarAnteojoArregloData.tieneCristalBlockOI,
      // idArticuloCristalBlockOI: actualizarAnteojoArregloData.idArticuloCristalBlockOI,

      quita_cristal_block_oi: actualizarAnteojoArregloData.quitaCristalBlockOI,
      cambia_cristal_block_oi: actualizarAnteojoArregloData.cambiaCristalBlockOI,
      quita_cambia_cristal_block_oi_causa:
        actualizarAnteojoArregloData.quitaCambiaCristalBlockOICausa,
      quita_cambia_cristal_block_oi_id_usuario_responsable:
        actualizarAnteojoArregloData.quitaCambiaCristalBlockOIIdUsuarioResponsable,
      quita_cambia_cristal_block_oi_motivo:
        actualizarAnteojoArregloData.quitaCambiaCristalBlockOIMotivo,
      cambia_por_id_articulo_cristal_block_oi:
        actualizarAnteojoArregloData.cambiaPorIdArticuloCristalBlockOI,

      agrega_cristal_block_oi: actualizarAnteojoArregloData.agregaCristalBlockOI,
      agrega_cristal_block_oi_id_articulo:
        actualizarAnteojoArregloData.agregaCristalBlockOIIdArticulo,
      agrega_cristal_block_oi_motivo: actualizarAnteojoArregloData.agregaCristalBlockOIMotivo,
    };
    save(_ActualizarAnteojoArregloObject);
  };
  //
  // ################################################################################
  //
  const save = async (parActualizaAnteojoArreglo) => {
    setIsDoingSomething(true);
    const response = await actualizaAnteojoArreglo(parActualizaAnteojoArreglo);
    setIsDoingSomething(false);
    if (response.ok) {
      onActualizarAnteojoArreglo();
    }
    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth="xl"
        fullWidth={true}
        scroll="body"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          ACTUALIZA {anteojoArreglo.toUpperCase()} {codigoAnteojoArreglo}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {!datosObtenidos && <> Cargando ...</>}

        {datosObtenidos && (
          <>
            <DialogContent dividers>
              <Accordion
                sx={{ border: "1px solid LightGrey", mb: 1, p: 0, borderRadius: "5px" }}
                expanded={accordionExpanded}
                onChange={() => {
                  setAccordionExpanded(!accordionExpanded);
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <DatosAccordion idGestionAtencion={idGestionAtencion} />
                </AccordionSummary>
                <AccordionDetails>
                  {datosAccordionSummaryCargados && (
                    <>
                      {idGestionAtencion && (
                        <DatosGestionAtencionCliente idGestionAtencion={idGestionAtencion} />
                      )}

                      {anteojoArreglo && (
                        <>
                          <DatosAnteojoArreglo
                            anteojoArreglo={anteojoArreglo}
                            idGcAnteojoArreglo={idGcAnteojoArreglo}
                          />

                          <DatosAreaActual
                            anteojoArreglo={anteojoArreglo}
                            idGcAnteojoArreglo={idGcAnteojoArreglo}
                            setAreaActual={getAreaActual}
                          />

                          <DatosBandejaActual
                            anteojoArreglo={anteojoArreglo}
                            idGcAnteojoArreglo={idGcAnteojoArreglo}
                            setBandejaActual={getBandejaActual}
                          />
                        </>
                      )}
                    </>
                  )}
                </AccordionDetails>
              </Accordion>

              <Box
                sx={{
                  border: "2px solid steelblue",
                  borderRadius: "5px",
                  p: 2,
                }}
              >
                <Grid container spacing={1} sx={{ mb: 1 }}>
                  {actualizarAnteojoArregloData.tieneArmAsolNuevo && (
                    <>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <DatosArticulo
                          tipoArticulo="armazon"
                          idArticulo={actualizarAnteojoArregloData.idArticuloArmAsolNuevo}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box sx={{ textAlign: "left" }}>
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            onClick={quitarArmAsolNuevo}
                            disabled={
                              actualizarAnteojoArregloData.quitaArmAsolNuevo ||
                              actualizarAnteojoArregloData.cambiaArmAsolNuevo
                            }
                          >
                            Quitar montura
                          </Button>
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            onClick={cambiarArmAsolNuevo}
                            disabled={
                              actualizarAnteojoArregloData.quitaArmAsolNuevo ||
                              actualizarAnteojoArregloData.cambiaArmAsolNuevo
                            }
                          >
                            Cambiar montura
                          </Button>
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            onClick={cancelarQuitarCambiarArmAsolNuevo}
                            disabled={
                              !actualizarAnteojoArregloData.quitaArmAsolNuevo &&
                              !actualizarAnteojoArregloData.cambiaArmAsolNuevo
                            }
                          >
                            Cancelar
                          </Button>
                        </Box>
                      </Grid>

                      {(actualizarAnteojoArregloData.quitaArmAsolNuevo ||
                        actualizarAnteojoArregloData.cambiaArmAsolNuevo) && (
                          <>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                              <ToggleButtonGroup
                                color="primary"
                                value={actualizarAnteojoArregloData.quitaCambiaArmAsolNuevoCausa}
                                exclusive={true}
                                onChange={handleChangeQuitarCambiarArmAsolNuevoPorTipo}
                              // fullWidth={true}
                              >
                                <ToggleButton value="rotura" sx={{ mr: 1 }} size="medium">
                                  Rotura
                                </ToggleButton>
                                <ToggleButton value="decision-cliente" size="medium">
                                  Decisión Cliente
                                </ToggleButton>
                                <ToggleButton value="decision-interna" size="medium">
                                  Decisión Interna
                                </ToggleButton>
                              </ToggleButtonGroup>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4}>
                              <Autocomplete
                                id="id-usuario-responsable"
                                size="small"
                                width="100%"
                                value={
                                  valueACUsuarioQuitaCambiaArmAsolNuevo &&
                                    valueACUsuarioQuitaCambiaArmAsolNuevo.id
                                    ? valueACUsuarioQuitaCambiaArmAsolNuevo
                                    : null
                                }
                                onChange={(event, newValue) => {
                                  setValueACUsuarioQuitaCambiaArmAsolNuevo(newValue);
                                  setActualizarAnteojoArregloData({
                                    ...actualizarAnteojoArregloData,
                                    quitaCambiaArmAsolNuevoIdUsuarioResponsable: newValue
                                      ? newValue.id
                                      : "",
                                  });
                                }}
                                inputValue={inputValueACUsuarioQuitaCambiaArmAsolNuevo}
                                onInputChange={(event, newInputValue) => {
                                  setInputValueACUsuarioQuitaCambiaArmAsolNuevo(
                                    newInputValue
                                  );
                                }}
                                options={usuarios}
                                getOptionLabel={(option) =>
                                  option.nombre + " " + option.apellido || ""
                                }
                                renderInput={(params) => (
                                  <TextField {...params} label="Usuario responsable" />
                                )}
                                isOptionEqualToValue={(option, value) => {
                                  if (!value || !value.id) return false;
                                  return option.id === value.id;
                                }}
                              />
                            </Grid>

                            <Grid item xs={12} sm={12} md={6} lg={6}>
                              <TextField
                                id="quitaCambiaArmAsolNuevoMotivo"
                                label="Motivo"
                                size="small"
                                sx={{ width: "100%" }}
                                inputProps={{
                                  autoComplete: "off",
                                  style: { textAlign: "left" },
                                }}
                                name="quitaCambiaArmAsolNuevoMotivo"
                                value={actualizarAnteojoArregloData.quitaCambiaArmAsolNuevoMotivo}
                                variant="outlined"
                                onChange={handleChange}
                              />
                            </Grid>

                            {actualizarAnteojoArregloData.cambiaArmAsolNuevo && (
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <AgregarArticulo
                                  tipoArticulo="armazon-anteojo-sol"
                                  onAgregarQuitarArticulo={cambiarArmAsolNuevoAgregarQuitarArticulo}
                                />
                              </Grid>
                            )}
                          </>
                        )}
                    </>
                  )}

                  {actualizarAnteojoArregloData.tieneMonturaCliente && (
                    <>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <DatosArticulo tipoArticulo="montura-cliente" />
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box sx={{ textAlign: "left" }}>
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            onClick={quitarMonturaCliente}
                            disabled={actualizarAnteojoArregloData.quitaMonturaCliente}
                          >
                            Quitar montura
                          </Button>
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            onClick={cancelarQuitarMonturaCliente}
                            disabled={!actualizarAnteojoArregloData.quitaMonturaCliente}
                          >
                            Cancelar
                          </Button>
                        </Box>
                      </Grid>

                      {actualizarAnteojoArregloData.quitaMonturaCliente && (
                        <>
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <ToggleButtonGroup
                              color="primary"
                              value={actualizarAnteojoArregloData.quitaMonturaClienteCausa}
                              exclusive={true}
                              onChange={handleChangeQuitarMonturaClientePorTipo}
                            // fullWidth={true}
                            >
                              <ToggleButton value="rotura" sx={{ mr: 1 }} size="medium">
                                Rotura
                              </ToggleButton>
                              <ToggleButton value="decision-cliente" size="medium">
                                Decisión Cliente
                              </ToggleButton>
                              <ToggleButton value="decision-interna" size="medium">
                                Decisión Interna
                              </ToggleButton>
                            </ToggleButtonGroup>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4} lg={4}>
                            <Autocomplete
                              id="id-usuario-responsable"
                              size="small"
                              width="100%"
                              value={
                                valueACUsuarioQuitaMonturaCliente &&
                                  valueACUsuarioQuitaMonturaCliente.id
                                  ? valueACUsuarioQuitaMonturaCliente
                                  : null
                              }
                              onChange={(event, newValue) => {
                                setValueACUsuarioQuitaMonturaCliente(newValue);
                                setActualizarAnteojoArregloData({
                                  ...actualizarAnteojoArregloData,
                                  quitaMonturaClienteIdUsuarioResponsable: newValue
                                    ? newValue.id
                                    : "",
                                });
                              }}
                              inputValue={inputValueACUsuarioQuitaMonturaCliente}
                              onInputChange={(event, newInputValue) => {
                                setInputValueACUsuarioQuitaMonturaCliente(newInputValue);
                              }}
                              options={usuarios}
                              getOptionLabel={(option) =>
                                option.nombre + " " + option.apellido || ""
                              }
                              renderInput={(params) => (
                                <TextField {...params} label="Usuario responsable" />
                              )}
                              isOptionEqualToValue={(option, value) => {
                                if (!value || !value.id) return false;
                                return option.id === value.id;
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} sm={12} md={6} lg={6}>
                            <TextField
                              id="quitaMonturaClienteMotivo"
                              label="Motivo"
                              size="small"
                              sx={{ width: "100%" }}
                              inputProps={{
                                autoComplete: "off",
                                style: { textAlign: "left" },
                              }}
                              name="quitaMonturaClienteMotivo"
                              value={actualizarAnteojoArregloData.quitaMonturaClienteMotivo}
                              variant="outlined"
                              onChange={handleChange}
                            />
                          </Grid>
                        </>
                      )}
                    </>
                  )}

                  {!actualizarAnteojoArregloData.tieneArmAsolNuevo &&
                    !actualizarAnteojoArregloData.tieneMonturaCliente && (
                      <>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <Typography variant="h6" gutterBottom>
                            Sin Armazón, Anteojo de sol o Montura de Cliente actualmente
                          </Typography>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <Box sx={{ textAlign: "left" }}>
                            <Button
                              sx={{ mr: 1 }}
                              variant="outlined"
                              onClick={agregarArmAsolNuevo}
                              disabled={
                                actualizarAnteojoArregloData.agregaArmAsolNuevo ||
                                actualizarAnteojoArregloData.agregaMonturaCliente
                              }
                            >
                              Agregar Armazón / Anteojo de sol
                            </Button>
                            <Button
                              sx={{ mr: 1 }}
                              variant="outlined"
                              onClick={agregarMonturaCliente}
                              disabled={
                                actualizarAnteojoArregloData.agregaArmAsolNuevo ||
                                actualizarAnteojoArregloData.agregaMonturaCliente
                              }
                            >
                              Agregar Montura de Cliente
                            </Button>
                            <Button
                              sx={{ mr: 1 }}
                              variant="outlined"
                              onClick={cancelarArmAsolNuevoMonturaCliente}
                              disabled={
                                !actualizarAnteojoArregloData.agregaArmAsolNuevo &&
                                !actualizarAnteojoArregloData.agregaMonturaCliente
                              }
                            >
                              Cancelar
                            </Button>
                          </Box>
                        </Grid>

                        {actualizarAnteojoArregloData.agregaArmAsolNuevo && (
                          <>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                              <AgregarArticulo
                                tipoArticulo="armazon-anteojo-sol"
                                onAgregarQuitarArticulo={agregarArmAsolNuevoAgregarArticulo}
                              />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12}>
                              <TextField
                                id="agregaArmAsolNuevoMotivo"
                                label="Motivo / detalles"
                                size="small"
                                sx={{ width: "100%" }}
                                inputProps={{
                                  autoComplete: "off",
                                  style: { textAlign: "left" },
                                }}
                                name="agregaArmAsolNuevoMotivo"
                                value={actualizarAnteojoArregloData.agregaArmAsolNuevoMotivo}
                                variant="outlined"
                                onChange={handleChange}
                              />
                            </Grid>
                          </>
                        )}

                        {actualizarAnteojoArregloData.agregaMonturaCliente && (
                          <>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                              <TextField
                                id="agregaMonturaClienteMotivo"
                                label="Motivo / detalles"
                                size="small"
                                sx={{ width: "100%" }}
                                inputProps={{
                                  autoComplete: "off",
                                  style: { textAlign: "left" },
                                }}
                                name="agregaMonturaClienteMotivo"
                                value={actualizarAnteojoArregloData.agregaMonturaClienteMotivo}
                                variant="outlined"
                                onChange={handleChange}
                              />
                            </Grid>
                          </>
                        )}
                      </>
                    )}
                </Grid>

                <Grid container spacing={1} sx={{ mb: 1 }}>
                  {actualizarAnteojoArregloData.tieneCristalBlockOD && (
                    <>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <DatosArticulo
                          tipoArticulo="cristal-block-od"
                          idArticulo={actualizarAnteojoArregloData.idArticuloCristalBlockOD}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box sx={{ textAlign: "left" }}>
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            onClick={() => {
                              quitarCristalBlock("OD");
                            }}
                            disabled={
                              actualizarAnteojoArregloData.quitaCristalBlockOD ||
                              actualizarAnteojoArregloData.cambiaCristalBlockOD
                            }
                          >
                            Quitar Cristal/Block OD
                          </Button>
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            onClick={() => {
                              cambiarCristalBlock("OD");
                            }}
                            disabled={
                              actualizarAnteojoArregloData.quitaCristalBlockOD ||
                              actualizarAnteojoArregloData.cambiaCristalBlockOD
                            }
                          >
                            Cambiar Cristal/Block OD
                          </Button>
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            onClick={() => {
                              cancelarQuitarCambiarCristalBlock("OD");
                            }}
                            disabled={
                              !actualizarAnteojoArregloData.quitaCristalBlockOD &&
                              !actualizarAnteojoArregloData.cambiaCristalBlockOD
                            }
                          >
                            Cancelar
                          </Button>
                        </Box>
                      </Grid>

                      {(actualizarAnteojoArregloData.quitaCristalBlockOD ||
                        actualizarAnteojoArregloData.cambiaCristalBlockOD) && (
                          <>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                              <ToggleButtonGroup
                                color="primary"
                                value={actualizarAnteojoArregloData.quitaCambiaCristalBlockODCausa}
                                exclusive={true}
                                onChange={handleChangeQuitarCambiarCristalBlockODPorTipo}
                              // fullWidth={true}
                              >
                                <ToggleButton value="rotura" sx={{ mr: 1 }} size="medium">
                                  Rotura
                                </ToggleButton>
                                <ToggleButton value="decision-cliente" size="medium">
                                  Decisión Cliente
                                </ToggleButton>
                                <ToggleButton value="decision-interna" size="medium">
                                  Decisión Interna
                                </ToggleButton>
                              </ToggleButtonGroup>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4}>
                              <Autocomplete
                                id="id-usuario-responsable-od"
                                size="small"
                                width="100%"
                                value={
                                  valueACUsuarioQuitaCristalBlockOD &&
                                    valueACUsuarioQuitaCristalBlockOD.id
                                    ? valueACUsuarioQuitaCristalBlockOD
                                    : null
                                }
                                onChange={(event, newValue) => {
                                  setValueACUsuarioQuitaCristalBlockOD(newValue);
                                  setActualizarAnteojoArregloData({
                                    ...actualizarAnteojoArregloData,
                                    quitaCambiaCristalBlockODIdUsuarioResponsable: newValue
                                      ? newValue.id
                                      : "",
                                  });
                                }}
                                inputValue={inputValueACUsuarioQuitaCristalBlockOD}
                                onInputChange={(event, newInputValue) => {
                                  setInputValueACUsuarioQuitaCristalBlockOD(newInputValue);
                                }}
                                options={usuarios}
                                getOptionLabel={(option) =>
                                  option.nombre + " " + option.apellido || ""
                                }
                                renderInput={(params) => (
                                  <TextField {...params} label="Usuario responsable" />
                                )}
                                isOptionEqualToValue={(option, value) => {
                                  if (!value || !value.id) return false;
                                  return option.id === value.id;
                                }}
                              />
                            </Grid>

                            <Grid item xs={12} sm={12} md={6} lg={6}>
                              <TextField
                                id="quitaCambiaCristalBlockODMotivo"
                                label="Motivo"
                                size="small"
                                sx={{ width: "100%" }}
                                inputProps={{
                                  autoComplete: "off",
                                  style: { textAlign: "left" },
                                }}
                                name="quitaCambiaCristalBlockODMotivo"
                                value={actualizarAnteojoArregloData.quitaCambiaCristalBlockODMotivo}
                                variant="outlined"
                                onChange={handleChange}
                              />
                            </Grid>

                            {actualizarAnteojoArregloData.cambiaCristalBlockOD && (
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <AgregarArticulo
                                  tipoArticulo="cristal-block-od"
                                  onAgregarQuitarArticulo={cambiarCristalBlockAgregarQuitarArticulo}
                                />
                              </Grid>
                            )}
                          </>
                        )}
                    </>
                  )}

                  {!actualizarAnteojoArregloData.tieneCristalBlockOD && (
                    <>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Typography variant="h6" gutterBottom>
                          Sin Cristal / Block para OD actualmente
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box sx={{ textAlign: "left" }}>
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            onClick={() => {
                              agregaCristalBlock("OD");
                            }}
                            disabled={actualizarAnteojoArregloData.agregaCristalBlockOD}
                          >
                            Agregar Cristal/Block OD
                          </Button>
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            onClick={() => {
                              cancelarAgregarCristalBlock("OD");
                            }}
                            disabled={!actualizarAnteojoArregloData.agregaCristalBlockOD}
                          >
                            Cancelar
                          </Button>
                        </Box>
                      </Grid>

                      {actualizarAnteojoArregloData.agregaCristalBlockOD && (
                        <>
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <AgregarArticulo
                              tipoArticulo="cristal-block-od"
                              onAgregarQuitarArticulo={agregaCristalBlockAgregarArticulo}
                            />
                          </Grid>

                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <TextField
                              id="agregaCristalBlockODMotivo"
                              label="Motivo / detalles"
                              size="small"
                              sx={{ width: "100%" }}
                              inputProps={{
                                autoComplete: "off",
                                style: { textAlign: "left" },
                              }}
                              name="agregaCristalBlockODMotivo"
                              value={actualizarAnteojoArregloData.agregaCristalBlockODMotivo}
                              variant="outlined"
                              onChange={handleChange}
                            />
                          </Grid>
                        </>
                      )}
                    </>
                  )}
                </Grid>

                <Grid container spacing={1} sx={{ mb: 1 }}>
                  {actualizarAnteojoArregloData.tieneCristalBlockOI && (
                    <>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <DatosArticulo
                          tipoArticulo="cristal-block-oi"
                          idArticulo={actualizarAnteojoArregloData.idArticuloCristalBlockOI}
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box sx={{ textAlign: "left" }}>
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            onClick={() => {
                              quitarCristalBlock("OI");
                            }}
                            disabled={
                              actualizarAnteojoArregloData.quitaCristalBlockOI ||
                              actualizarAnteojoArregloData.cambiaCristalBlockOI
                            }
                          >
                            Quitar Cristal/Block OI
                          </Button>
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            onClick={() => {
                              cambiarCristalBlock("OI");
                            }}
                            disabled={
                              actualizarAnteojoArregloData.quitaCristalBlockOI ||
                              actualizarAnteojoArregloData.cambiaCristalBlockOI
                            }
                          >
                            Cambiar Cristal/Block OI
                          </Button>
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            onClick={() => {
                              cancelarQuitarCambiarCristalBlock("OI");
                            }}
                            disabled={
                              !actualizarAnteojoArregloData.quitaCristalBlockOI &&
                              !actualizarAnteojoArregloData.cambiaCristalBlockOI
                            }
                          >
                            Cancelar
                          </Button>
                        </Box>
                      </Grid>

                      {(actualizarAnteojoArregloData.quitaCristalBlockOI ||
                        actualizarAnteojoArregloData.cambiaCristalBlockOI) && (
                          <>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                              <ToggleButtonGroup
                                color="primary"
                                value={actualizarAnteojoArregloData.quitaCambiaCristalBlockOICausa}
                                exclusive={true}
                                onChange={handleChangeQuitarCambiarCristalBlockOIPorTipo}
                              // fullWidth={true}
                              >
                                <ToggleButton value="rotura" sx={{ mr: 1 }} size="medium">
                                  Rotura
                                </ToggleButton>
                                <ToggleButton value="decision-cliente" size="medium">
                                  Decisión Cliente
                                </ToggleButton>
                                <ToggleButton value="decision-interna" size="medium">
                                  Decisión Interna
                                </ToggleButton>
                              </ToggleButtonGroup>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4}>
                              <Autocomplete
                                id="id-usuario-responsable-oi"
                                size="small"
                                width="100%"
                                value={
                                  valueACUsuarioQuitaCristalBlockOI &&
                                    valueACUsuarioQuitaCristalBlockOI.id
                                    ? valueACUsuarioQuitaCristalBlockOI
                                    : null
                                }
                                onChange={(event, newValue) => {
                                  setValueACUsuarioQuitaCristalBlockOI(newValue);
                                  setActualizarAnteojoArregloData({
                                    ...actualizarAnteojoArregloData,
                                    quitaCambiaCristalBlockOIIdUsuarioResponsable: newValue
                                      ? newValue.id
                                      : "",
                                  });
                                }}
                                inputValue={inputValueACUsuarioQuitaCristalBlockOI}
                                onInputChange={(event, newInputValue) => {
                                  setInputValueACUsuarioQuitaCristalBlockOI(newInputValue);
                                }}
                                options={usuarios}
                                getOptionLabel={(option) =>
                                  option.nombre + " " + option.apellido || ""
                                }
                                renderInput={(params) => (
                                  <TextField {...params} label="Usuario responsable" />
                                )}
                                isOptionEqualToValue={(option, value) => {
                                  if (!value || !value.id) return false;
                                  return option.id === value.id;
                                }}
                              />
                            </Grid>

                            <Grid item xs={12} sm={12} md={6} lg={6}>
                              <TextField
                                id="quitaCambiaCristalBlockOIMotivo"
                                label="Motivo"
                                size="small"
                                sx={{ width: "100%" }}
                                inputProps={{
                                  autoComplete: "off",
                                  style: { textAlign: "left" },
                                }}
                                name="quitaCambiaCristalBlockOIMotivo"
                                value={actualizarAnteojoArregloData.quitaCambiaCristalBlockOIMotivo}
                                variant="outlined"
                                onChange={handleChange}
                              />
                            </Grid>

                            {actualizarAnteojoArregloData.cambiaCristalBlockOI && (
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <AgregarArticulo
                                  tipoArticulo="cristal-block-oi"
                                  onAgregarQuitarArticulo={cambiarCristalBlockAgregarQuitarArticulo}
                                />
                              </Grid>
                            )}
                          </>
                        )}
                    </>
                  )}

                  {!actualizarAnteojoArregloData.tieneCristalBlockOI && (
                    <>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Typography variant="h6" gutterBottom>
                          Sin Cristal / Block para OI actualmente
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box sx={{ textAlign: "left" }}>
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            onClick={() => {
                              agregaCristalBlock("OI");
                            }}
                            disabled={actualizarAnteojoArregloData.agregaCristalBlockOI}
                          >
                            Agregar Cristal/Block OI
                          </Button>
                          <Button
                            sx={{ mr: 1 }}
                            variant="outlined"
                            onClick={() => {
                              cancelarAgregarCristalBlock("OI");
                            }}
                            disabled={!actualizarAnteojoArregloData.agregaCristalBlockOI}
                          >
                            Cancelar
                          </Button>
                        </Box>
                      </Grid>

                      {actualizarAnteojoArregloData.agregaCristalBlockOI && (
                        <>
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <AgregarArticulo
                              tipoArticulo="cristal-block-oi"
                              onAgregarQuitarArticulo={agregaCristalBlockAgregarArticulo}
                            />
                          </Grid>

                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <TextField
                              id="agregaCristalBlockOIMotivo"
                              label="Motivo / detalles"
                              size="small"
                              sx={{ width: "100%" }}
                              inputProps={{
                                autoComplete: "off",
                                style: { textAlign: "left" },
                              }}
                              name="agregaCristalBlockOIMotivo"
                              value={actualizarAnteojoArregloData.agregaCristalBlockOIMotivo}
                              variant="outlined"
                              onChange={handleChange}
                            />
                          </Grid>
                        </>
                      )}
                    </>
                  )}
                </Grid>
              </Box>
            </DialogContent>

            <DialogActions>
              <Box sx={{ textAlign: "right", p: 1 }}>
                <Button
                  sx={{ mr: 1, backgroundColor: "warning" }}
                  variant="contained"
                  onClick={() => {
                    ActualizarAnteojoArreglo();
                  }}
                  startIcon={<EditCalendarOutlinedIcon />}
                  disabled={isDoingSomething}
                >
                  Actualizar
                </Button>
                <Button
                  sx={{ mr: 1 }}
                  variant="outlined"
                  onClick={handleCloseDialog}
                  disabled={isDoingSomething}
                >
                  Cancelar
                </Button>
              </Box>
            </DialogActions>
          </>
        )}
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ActualizarAnteojoArregloDialog;
